import { defineSchema, SchemaInstance } from "../type-system/schema";
import {
  baseTrackingSchema,
  exampleBaseTrackingSchemaInstance,
} from "./tracking/base-tracking";

export const baseNewFulfillmentGroupSchema = defineSchema({
  fields: {
    groupId: {
      dataType: "Text",
      documentation: "Redo internal _id for the fulfillment group",
    },
  },
});

export const examplebaseNewFulfillmentGroupInstance: SchemaInstance<
  typeof baseNewFulfillmentGroupSchema
> =
  // cspell:disable-next-line
  { groupId: "6891f5cbb1zfec0007611061" };

export function createbaseNewFulfillmentGroupInstance(
  groupId: string,
): SchemaInstance<typeof baseNewFulfillmentGroupSchema> {
  return { groupId };
}

export const baseOmsOrderReadyForPickupSchema = defineSchema({
  fields: {
    pickupStoreAddress1: {
      dataType: "Maybe Text",
      documentation: "The first line of the pickup store address",
    },
    pickupStoreAddress2: {
      dataType: "Maybe Text",
      documentation: "The second line of the pickup store address",
    },
    pickupStoreCity: {
      dataType: "Maybe Text",
      documentation: "The city of the pickup store address",
    },
    pickupStoreProvince: {
      dataType: "Maybe Text",
      documentation: "The province of the pickup store address",
    },
    pickupStoreZip: {
      dataType: "Maybe Text",
      documentation: "The zip code of the pickup store address",
    },
    pickupStoreCountryCode: {
      dataType: "Maybe Text",
      documentation: "The country code of the pickup store address",
    },
    pickupStoreName: {
      dataType: "Maybe Text",
      documentation: "The name of the pickup store",
    },
    pickupStoreEmail: {
      dataType: "Maybe Text",
      documentation: "The email of the pickup store",
    },
    pickupStorePhone: {
      dataType: "Maybe Text",
      documentation: "The phone number of the pickup store",
    },
    ...baseTrackingSchema.fields,
  },
});

export const examplebaseOmsOrderReadyForPickupInstance: SchemaInstance<
  typeof baseOmsOrderReadyForPickupSchema
> = {
  pickupStoreAddress1: "123 Main St",
  pickupStoreAddress2: "Apt 1",
  pickupStoreCity: "Anytown",
  pickupStoreProvince: "CA",
  pickupStoreZip: "12345",
  pickupStoreCountryCode: "US",
  pickupStoreName: "Pickup Store",
  pickupStoreEmail: "pickup@store.com",
  pickupStorePhone: "123-456-7890",
  ...exampleBaseTrackingSchemaInstance,
};

export const baseOmsLabelPurchasedSchema = defineSchema({
  fields: { ...baseTrackingSchema.fields },
});

export const examplebaseOmsLabelPurchasedInstance: SchemaInstance<
  typeof baseOmsLabelPurchasedSchema
> = { ...exampleBaseTrackingSchemaInstance };

export const baseAddressVerificationFailedSchema = defineSchema({
  fields: {
    addressError: {
      dataType: "Text",
      documentation: "Error message from address verification",
    },
    customerPortalLink: {
      dataType: "Url",
      documentation: "Deep link to customer portal address editing",
    },
    merchantName: { dataType: "Text", documentation: "Name of the merchant" },
    orderNumber: { dataType: "Text", documentation: "Order number" },
    redoCustomerId: { dataType: "Text", documentation: "Redo customer ID" },
    customerEmail: {
      dataType: "Email",
      documentation: "The email address of the customer",
    },
    customerFirstName: {
      dataType: "Maybe Text",
      documentation: "The first name of the customer",
      hideFromConditionStep: true,
    },
    redoId: {
      dataType: "Text",
      documentation: "The unique identifier for the trackable item in Redo",
      hideFromInsertionModal: true,
    },
    trackableType: {
      dataType: "Enum",
      documentation:
        'The type of trackable item: "order", "return", or "fulfillment_group"',
      values: ["order", "return", "fulfillment_group"],
    },
  },
});

export const examplebaseAddressVerificationFailedInstance: SchemaInstance<
  typeof baseAddressVerificationFailedSchema
> = {
  ...exampleBaseTrackingSchemaInstance,
  addressError: "Unable to verify shipping address",
  customerPortalLink: "https://portal.example.com/edit-address?token=abc123",
  merchantName: "Example Merchant",
};
